import { render, staticRenderFns } from "./ZhanhuiD.vue?vue&type=template&id=3725170d&scoped=true"
import script from "./ZhanhuiD.vue?vue&type=script&lang=js"
export * from "./ZhanhuiD.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiD.vue?vue&type=style&index=0&id=3725170d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3725170d",
  null
  
)

export default component.exports